module.exports = __webpack_public_path__ + "img/asuncion_center.f973eb48.png";